import React from 'react';
import { observer } from 'mobx-react-lite';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import styles from './AutoReplyCustomAwayMessage.module.css';
import AutoReplyCustomAwayMessageSwitches from '../AutoReplyCustomAwayMessageSwitches/AutoReplyCustomAwayMessageSwitches';
import AutoReplyCustomAwayMessageExpirationDropdown from '../AutoReplyCustomAwayMessageExpirationDropdown/AutoReplyCustomAwayMessageExpirationDropdown';
import AutoReplyEditButtons from '../AutoReplyEditButtons/AutoReplyEditButtons';
import {
  getDifferenceBetweenDatesInMilliseconds,
  isDateBeforeCurrentDate,
} from '../../../../../helpers/dateHelpers';

const tableRow = {
  root: styles.tableRow,
};

const tableCell = {
  root: styles.tableCell,
};

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const AutoReplyCustomAwayMessage = observer(function AutoReplyCustomAwayMessage(props) {
  const { data } = props;
  const [hasAutoReplyExpired, setHasAutoReplyExpired] = React.useState(
    () => (data?.ExpirationTime ? isDateBeforeCurrentDate(data.ExpirationTime) : false),
    []
  );

  React.useEffect(() => {
    let timeout;
    if (
      data?.ExpirationTime &&
      (data?.IsActiveForTextChat || data?.IsActiveForWebChat) &&
      !isDateBeforeCurrentDate(data.ExpirationTime)
    ) {
      const timeDifference = getDifferenceBetweenDatesInMilliseconds(data.ExpirationTime);

      timeout = setTimeout(() => {
        setHasAutoReplyExpired(true);
      }, timeDifference);
    }

    return () => {
      clearTimeout(timeout);
      setHasAutoReplyExpired(false);
    };
  }, [data?.ExpirationTime, data?.IsActiveForTextChat, data?.IsActiveForWebChat]);

  return (
    <TableRow key={data._id} classes={tableRow}>
      <TableCell classes={tableCell} style={{ width: 166 }}>
        <div className={[styles.tableCellItem, styles.tableCellItemStart, styles.bold].join(' ')}>
          <AutoReplyCustomAwayMessageSwitches
            data={data}
            hasAutoReplyExpired={hasAutoReplyExpired}
          />
        </div>
      </TableCell>
      <TableCell classes={tableCell} style={{ width: 201 }}>
        <div className={[styles.tableCellItem, styles.bold].join(' ')}>
          <span className={styles.tableData}>{data.Title}</span>
        </div>
      </TableCell>
      <TableCell classes={tableCell}>
        <div className={styles.tableCellItem}>
          <span className={styles.tableData}>{data.Message}</span>
        </div>
      </TableCell>
      <TableCell classes={tableCell} style={{ width: 255 }}>
        <div className={styles.tableCellItem}>
          {(data?.IsActiveForTextChat || data?.IsActiveForWebChat) && !hasAutoReplyExpired ? (
            <AutoReplyCustomAwayMessageExpirationDropdown data={data} />
          ) : null}
        </div>
      </TableCell>
      <TableCell classes={tableCell} style={{ width: 70 }}>
        <div className={[styles.tableCellItem, styles.tableCellItemEnd].join(' ')}>
          <AutoReplyEditButtons data={data} />
        </div>
      </TableCell>
    </TableRow>
  );
});
AutoReplyCustomAwayMessage.whyDidYouRender = true;
AutoReplyCustomAwayMessage.displayName = 'AutoReplyCustomAwayMessage';

export default AutoReplyCustomAwayMessage;
